<script>
  export default {
    name: 'Home',
    mounted: function () {
      this.$router.push({ name: 'Dashboard' })
    }
  }
</script>